import { render, staticRenderFns } from "./EmailTemplateModal.vue?vue&type=template&id=1c67786e&scoped=true&"
import script from "./EmailTemplateModal.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateModal.vue?vue&type=style&index=0&id=1c67786e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c67786e",
  null
  
)

export default component.exports